import { timeMap, formatTime, resultFormat } from './zh';
export default {
    punctuation: {
        comma: "、",
        comma2: "，",
    },
    stitching: (...strList) => strList.join(""),
    book: (name) => `《${name}》`,
    now: (name) => "立即" + name,
    please: (name) => "請" + name,
    numberFormat(num, useEn = false) {
        const unit = useEn ? "w" : "萬";
        if (!num) {
            return 0;
        }
        if (num < 10000) {
            return num;
        }
        if (num < 100000000) {
            return (num / 10000).toFixed(1) + unit;
        }
        return `9999.9${unit}+`;
    },
    relativeTime(time) {
        const old = new Date(time);
        const now = new Date().getTime();
        const num = now - time;
        const year = old.getFullYear(), mon = old.getMonth() + 1, day = old.getDate(), hour = old.getHours();
        let min = old.getMinutes();
        if (min <= 9) {
            min = `0${min}`;
        }
        if (num >= timeMap.YEAR) {
            return `${year}-${mon}-${day}`;
        }
        const TODAY = new Date(new Date().setHours(0, 0, 0, 0)).getTime(); // 零点
        const YESTERDAY = TODAY - timeMap.DAY;
        if (time < YESTERDAY) {
            return `${mon}-${day}`;
        }
        if (TODAY >= time && time >= YESTERDAY) {
            return `昨天 ${hour}:${min}`;
        }
        if (num >= timeMap.HOUR) {
            return `${hour}:${min}`;
        }
        if (num < timeMap.MIN * 3) {
            return "剛剛";
        }
        return `${resultFormat(num)}分鐘前`;
    },
    absoluteTime: formatTime,
};
